import { login } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useAuthStore } from '../../../store';
import { useMutation } from '@tanstack/react-query';

const useLogin = () => {
    const setAuthToken = useAuthStore((state) => state.setAuthToken);
    const setUserProfile = useAuthStore((state) => state.setUserProfile);

    const loginMutation = useMutation({
        mutationKey: 'login',
        mutationFn: (model) => login(model),
        onSuccess: (data) => {
            setAuthToken(data.token);
            setUserProfile(data.profile);
            notifications.show({
                title: 'Success',
                message: 'Successfully logged in!',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return loginMutation;
};
export default useLogin;
